import React from 'react';
import MapSingle from '../../map/MapSingle';
import EventsListing from '../../sections/EventsListing';
import {useCategories, useInfiniteEvents} from '../../../api/hooks';
import Loader from '../Loader';
import Error from '../Error';
import {Translate} from '../../../config/TranslationProvider';
import Description from '../../sections/Description';
import Address from '../../sections/Address';
import TagList from '../../sections/TagList';
import OpeningHours from '../../sections/OpeningHours';
import ImageHeader from '../head/ImageHeader';
import Title from '../layout/Title';

const LocationContent = ({location}) => {
    const {
        data: eventGroups,
        isLoading: eventsLoading,
        error: eventsError,
        fetchMore,
        canFetchMore,
        isFetchingMore,
    } = useInfiniteEvents({'end_date_from': 'today', 'locations': location.id});

    const {data: categories, isLoading: categoriesLoading, error: categoriesError} = useCategories();

    if (eventsLoading || categoriesLoading) {
        return <Loader />;
    }

    if (eventsError || categoriesError) {
        return <Error errors={[eventsError && eventsError, categoriesError && categoriesError]} />;
    }

    return (
        <>
            <ImageHeader location={location} type="locationDetails" />
            <section className="directory_listing_detail_area single_area section-bg section-padding-strict">
                <Title>{location.title}</Title>
                <div className="container">
                    <div className="row">
                        {/* Left Side */}
                        <div className="col-lg-8">

                            {location?.description && <Description description={location.description} />}

                            {location && <MapSingle location={location} title="host_location" resource="location" />}

                        </div>

                        {/* Right Side */}
                        <div className="col-lg-4">

                            {location && <Address location={location} />}

                            {location?.opening_hours.length > 0 && <OpeningHours openingTimes={location.opening_hours} />}

                            {location?.tags.length > 0 && <TagList tags={location.tags} routeName="locations" />}

                        </div>

                        {eventGroups[0]?.data?.length > 0 && (
                            <div className="col-12">
                                <div className="atbd_content_module">
                                    <div className="atbd_content_module__tittle_area">
                                        <div className="atbd_area_title">
                                            <h3 className="h4"><span className="la la-group" />&nbsp;
                                                <Translate value="events" />
                                            </h3>
                                        </div>
                                    </div>
                                    <div className="atbdb_content_module_contents">
                                        <EventsListing
                                            type="grid4"
                                            eventGroups={eventGroups}
                                            fetchMore={fetchMore}
                                            canFetchMore={canFetchMore}
                                            isFetchingMore={isFetchingMore}
                                            categories={categories}
                                        />
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </section>
        </>
    );
};


export default LocationContent;
